import { render, staticRenderFns } from "./sparePartsC.vue?vue&type=template&id=556a3154&scoped=true&"
import script from "./sparePartsC.vue?vue&type=script&lang=js&"
export * from "./sparePartsC.vue?vue&type=script&lang=js&"
import style0 from "./sparePartsC.vue?vue&type=style&index=0&id=556a3154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556a3154",
  null
  
)

export default component.exports